// Mock data for Romero Sumpter website

export const siteData = {
  hero: {
    name: "Romero Sumpter",
    tagline: "Minister • Author • Master Clothier",
    description: "Anointed to Inspire • Gifted to Create • Driven to Build",
    profileImage: "https://customer-assets.emergentagent.com/job_18d2d639-f4e1-4915-80f9-3d48232ed8cc/artifacts/fh0bmavb_IMG_6031.jpg",
    shopImage: "https://customer-assets.emergentagent.com/job_18d2d639-f4e1-4915-80f9-3d48232ed8cc/artifacts/rn2olz2c_Romero%20in%20Suit%20Shop%20%281%29.png"
  },

  ministry: {
    title: "Ministry",
    subtitle: "Anointed to Inspire",
    description: "Spreading the Gospel through powerful messages, inspiring videos, and transformative events.",
    messages: [
      {
        id: 1,
        title: "He Waits at the Gates",
        date: "2025-11-27",
        type: "sermon",
        description: "A powerful Thanksgiving Day message exploring Psalm 100:4 and the pattern of approaching God through thanksgiving. Discover how God waits at the gates of your heart.",
        audioUrl: "#",
        videoUrl: "https://customer-assets.emergentagent.com/job_author-books/artifacts/7mnt85ov_He%20Waits%20at%20the%20Gates.mp4",
        duration: null,
        image: "https://customer-assets.emergentagent.com/job_author-books/artifacts/tkxrmis2_He%20Waits%20at%20the%20Gates.jpg",
        hasStudyGuide: true
      },
      {
        id: 2,
        title: "The Same Hand",
        date: null,
        type: "sermon",
        scripture: "Mark 8:22-25",
        description: "A revelatory message from Mark 8:22-25 — the healing of the blind man at Bethsaida. The same Hand that touches you to bring you out is the same Hand that touches you again to bring you into clarity. God's process is intentional; His second touch is just as anointed as His first.",
        audioUrl: "#",
        videoUrl: "https://customer-assets.emergentagent.com/job_d4801e57-518e-48e3-b04b-23ec30a7a74e/artifacts/yv8elius_The%20Same%20Hand.mp4",
        duration: null,
        image: null,
        hasStudyGuide: true
      }
    ],
    videos: [
      {
        id: 1,
        title: "Prophetic Release",
        date: "2025-09-01",
        videoUrl: "https://customer-assets.emergentagent.com/job_author-books/artifacts/3mquyxyv_Prophetic%20Release.mp4",
        thumbnail: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=600&h=400&fit=crop",
        duration: "Video Available"
      },
      {
        id: 2,
        title: "Things are looking UP",
        date: null,
        videoUrl: "https://customer-assets.emergentagent.com/job_author-books/artifacts/q93u34lj_look%20up.mp4",
        thumbnail: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&h=400&fit=crop",
        duration: "Video Available"
      }
    ],
    events: [
      {
        id: 1,
        title: "Peak Dwellers Summit",
        date: "2025-10-17",
        time: "October 17-19, 2025",
        location: "Kingdom Authority Ministries, 1302 Lapeer Avenue, Port Huron, MI",
        description: "Join Prophet R. Quinel Sumpter and other anointed speakers at the Peak Dwellers Summit. Theme: 'Nothing Shall Be As It Was - New Order, New Move, New Era.' Hosted by Apostle Keith Wyett, Sr. & Prophet Shalita Marie Wyett.",
        image: "https://customer-assets.emergentagent.com/job_author-books/artifacts/1221se3v_1000004556.jpg",
        registrationLink: "#"
      },
      {
        id: 2,
        title: "Southern Illinois Annual Conference - Love One Another",
        date: "2025-08-15",
        time: "August 15, 2025 - 6:30 PM",
        location: "Olivet Free Will Baptist Church, 409 N Marion St, Carbondale, IL 62901",
        description: "Guest Workshop Facilitator Prophet Romero Sumpter presents 'Love Through It All' workshop. Theme: Love One Another (John 13:34). Features The Power of Love, The Purpose of Love, and The Presence of Love. Annual Bishop Anteco Bryant Sr. presiding.",
        image: "https://customer-assets.emergentagent.com/job_author-books/artifacts/8dqxcu2s_1000004616.jpg",
        registrationLink: "#"
      },
      {
        id: 3,
        title: "Live Thanksgiving Day Service",
        date: "2025-11-27",
        time: "November 27, 2025 - 10:00 AM",
        location: "Live Church STL, 215 Shelley Drive, St. Louis, MO 63137",
        description: "Join us for a special Thanksgiving Day Service featuring Prophet Romero Sumpter as speaker. Led by Bishop Shadrach D. Martin, Lead Pastor. A time of gratitude, worship, and powerful ministry to celebrate God's faithfulness.",
        image: "https://customer-assets.emergentagent.com/job_author-books/artifacts/mhdcjlqu_Live%20Thanksgiving%20Service.jpg",
        registrationLink: "#"
      },
      {
        id: 4,
        title: "Fresh Fire - Hour of Power",
        date: "2026-05-13",
        time: "May – July 2026 | 2nd & 4th Wednesdays @ 6:00 PM (Intercession 5:45 PM)",
        location: "215 Shepley Drive, St. Louis, MO",
        description: "Ignite — Hebrews 12:29. A powerful Hour of Power series spanning May through July. Schedule: May 13 – Eld. Romero • May 27 – Eld. Lucretia • June 10 – Min. Georgia • June 24 – Evg. Sheree • July 08 – MIT Carmen • July 22 – Eld. Romero.",
        image: "https://customer-assets.emergentagent.com/job_d4801e57-518e-48e3-b04b-23ec30a7a74e/artifacts/omv4yrlx_1000023173.jpg",
        registrationLink: "#"
      },
      {
        id: 5,
        title: "Behind the Leader — Leadership Workshop",
        date: "2026-08-15",
        time: "Saturday, August 15, 2026 — 6:00 PM",
        location: "Ira Grove Free Will Baptist Church, 1701 Belmont Ave, East St. Louis, IL",
        description: "Southern Illinois Annual Conference of Free Will Baptist • Carbondale District Conference Joint Session. Featuring Romero Q. Sumpter Sr., author of 'Behind the Leader.' Everyone celebrates the leader… few understand the one standing behind them. Discover the biblical principles of effective secondary leadership, loyalty, vision, trust, stewardship, and carrying another person's assignment without losing your own identity. Topics: The Office over the Officer • Carrying Another Man's Vision • Hidden Leadership • Trust & Loyalty • Character Before Position • Learning to Lead While Serving • Preparing for Your Next Assignment. Ideal for Ministry Leaders, Armor Bearers, Executive Pastors, Administrative Leaders, Elders & Deacons, Church Staff, Emerging Leaders, and Business Leaders. Conference registration includes workshop admission.",
        image: "https://customer-assets.emergentagent.com/job_d4801e57-518e-48e3-b04b-23ec30a7a74e/artifacts/02j5jfrt_Behind%20The%20Leader%20Workshop%20Flyer.jpg",
        registrationLink: "#"
      },
      {
        id: 6,
        title: "PeakDwellers Summit 2026",
        date: "2026-10-15",
        time: "October 15 – 18, 2026",
        location: "EKG International Fellowship • 1302 Lapeer Avenue, Port Huron, MI 48060",
        description: "A four-day summit hosted by Apostle Keith Wyett Sr. and EKG International Fellowship. Featuring Apostle John Veal, Bishop Alvernis Johnson, Dr. Bernadine Bell-McGhee, Overseer Romero Sumpter, Apostle Clifford Davis, Apostle Margaret S. Wyett, Apostle Yolanda Scott, Apostle P.A. Williams, Apostle Shalita Marie, and featured Stellar Award-winning artist Amethyst. Come rise to the peak in worship, prophetic revelation, and kingdom empowerment.",
        image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_d4801e57-518e-48e3-b04b-23ec30a7a74e/artifacts/4ktjcwly_1000028330.webp",
        registrationLink: "#"
      }
    ],
    podcasts: [
      {
        id: 1,
        title: "Lovers of Themselves - Episode 1",
        subtitle: "Teaching with Romero Sumpter Sr.",
        date: "2026-02-01",
        status: "available",
        description: "An insightful teaching exploring the dangers of self-love and narcissism in modern society. Join Prophet Romero Sumpter Sr. for powerful biblical insights on this critical topic.",
        image: "https://customer-assets.emergentagent.com/job_author-books/artifacts/y75row4s_Lovers%20Flyer.png",
        duration: "Episode 1",
        series: "Biblical Teachings",
        audioUrl: "https://customer-assets.emergentagent.com/job_author-books/artifacts/zwo4h5bt_Lovers%20of%20Themselves%20Episode%201.wav"
      },
      {
        id: 2,
        title: "Lovers of Themselves - Episode 2",
        subtitle: "Teaching with Romero Sumpter Sr.",
        date: "2026-02-08",
        status: "available",
        description: "Continuing the powerful series on self-love and narcissism. Dive deeper into biblical truths about humility, service, and God-centered living with Prophet Romero Sumpter Sr.",
        image: "https://customer-assets.emergentagent.com/job_author-books/artifacts/y75row4s_Lovers%20Flyer.png",
        duration: "Episode 2",
        series: "Biblical Teachings",
        audioUrl: "https://customer-assets.emergentagent.com/job_author-books/artifacts/tykxj5iu_Lovers_of%20themselves%20episode%202%20_%20feb%2007%2C%202026.mp3"
      }
    ]
  },

  books: {
    title: "Books",
    subtitle: "Published Author",
    description: "Inspiring literature that touches hearts and transforms lives through faith, love, and leadership.",
    published: [
      {
        id: 2,
        title: "Behind the Leader",
        subtitle: "Effective Secondary Leadership",
        cover: "https://customer-assets.emergentagent.com/job_d4801e57-518e-48e3-b04b-23ec30a7a74e/artifacts/bcdpr666_Behind%20the%20leader%203D%20mockup.png",
        coverContain: false,
        description: "You don't always lead from the front to make a lasting impact. Everyone celebrates the leader… few understand the one standing behind them. In Behind the Leader, Romero Sumpter unveils the biblical and practical principles of effective secondary leadership — loyalty, vision stewardship, trust, character, and carrying another person's assignment without losing your own identity. A field manual for armor bearers, executive pastors, ministry leaders, elders, deacons, administrative leaders, emerging leaders, and anyone called to support and strengthen leadership.",
        genre: "Leadership / Christian Living",
        pages: null,
        publishDate: "2026",
        purchaseLink: "https://www.amazon.com/dp/B0H6YP3VZS",
        price: "Amazon",
        status: "Now Available on Amazon",
        reviews: null
      },
      {
        id: 1,
        title: "Love Through It All",
        cover: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=400&h=600&fit=crop",
        description: "Love changes everything. It heals wounds, restores relationships, strengthens faith, and leaves a lasting legacy. In Love Through It All, Romero Q. Sumpter challenges readers to rise above cultural definitions of love and embrace the biblical model: love that gives, forgives, serves, and endures. With powerful scripture references, practical examples, and life-application questions, this book is more than words—it's an invitation to transformation. Whether you're seeking to deepen your faith, strengthen your marriage, or learn to love others as Christ loves you, this book equips you to live out love in its truest form.",
        genre: "Christian Living",
        pages: 248,
        publishDate: "2023",
        purchaseLink: "https://www.lulu.com/shop/romero-sumpter/love-through-it-all/ebook/product-4585mrg.html?q=romero+sumpter&page=1&pageSize=4",
        price: "$7.99",
        reviews: [
          {
            name: "Sarah Johnson",
            rating: 5,
            comment: "This book completely transformed my perspective on love and faith. Highly recommended!"
          },
          {
            name: "Michael Brown",
            rating: 5,
            comment: "Pastor Sumpter's wisdom shines through every page. A must-read for anyone seeking spiritual growth."
          }
        ]
      }
    ]
  },

  homeAnnouncements: {
    newBook: {
      eyebrow: "NEW RELEASE",
      title: "Behind the Leader",
      subtitle: "Effective Secondary Leadership",
      tagline: "You don't always lead from the front to make a lasting impact.",
      description: "A biblical and practical field manual for armor bearers, executive pastors, ministry leaders, and anyone called to serve, steward, and strengthen leadership.",
      cover: "https://customer-assets.emergentagent.com/job_d4801e57-518e-48e3-b04b-23ec30a7a74e/artifacts/bcdpr666_Behind%20the%20leader%203D%20mockup.png",
      youtubeId: "4qjHq2Aqyg0",
      youtubeUrl: "https://youtu.be/4qjHq2Aqyg0",
      ctaLabel: "Buy on Amazon",
      ctaLink: "https://www.amazon.com/dp/B0H6YP3VZS"
    },
    academy: {
      eyebrow: "COMING SOON",
      title: "Secondary Leadership Academy",
      subtitle: "A Biblical and Practical Training Program for Effective Secondary Leadership",
      institute: "Romero Sumpter Leadership Institute",
      flyer: "https://customer-assets.emergentagent.com/job_d4801e57-518e-48e3-b04b-23ec30a7a74e/artifacts/q632x6xw_Secondary%20Leadership%20Academy%20Coming%20Soon.png",
      ctaLabel: "Preview the Academy",
      ctaLink: "/academy"
    }
  },

  academy: {
    title: "Secondary Leadership Academy",
    institute: "Romero Sumpter Leadership Institute",
    certificate: "Certificate in Biblical & Executive Secondary Leadership",
    duration: "12 Weeks",
    format: "Live Online or In-Person",
    instructor: "Romero Sumpter",
    awarded: "Certificate Awarded Upon Successful Completion",
    flyer: "https://customer-assets.emergentagent.com/job_d4801e57-518e-48e3-b04b-23ec30a7a74e/artifacts/q632x6xw_Secondary%20Leadership%20Academy%20Coming%20Soon.png",
    takeHomeImage: "https://customer-assets.emergentagent.com/job_d4801e57-518e-48e3-b04b-23ec30a7a74e/artifacts/drd04c1n_Secondary%20LEadership%20Acadamy%20Mock%20up%20What%20youll%20take%20home.png",
    overview: [
      "The Secondary Leadership Academy is a comprehensive twelve-week leadership development program designed to equip current and aspiring secondary leaders with the biblical foundation, executive leadership principles, and practical administrative skills necessary to effectively support and strengthen organizational vision.",
      "Unlike traditional leadership courses that focus primarily on the senior leader, this academy is uniquely designed for executive pastors, assistant pastors, church administrators, ministry leaders, department heads, executive assistants, board members, nonprofit leaders, and anyone serving in a supporting leadership role.",
      "Students will receive practical instruction, biblical leadership principles, executive leadership training, and real-world ministry administration tools that can be immediately implemented within their local church or organization."
    ],
    outcomes: [
      "Understand the biblical role of secondary leadership.",
      "Lead with honor, integrity, and servant leadership.",
      "Steward another leader's vision with excellence.",
      "Build healthy ministry systems.",
      "Develop executive leadership and administrative skills.",
      "Organize conferences and ministry events.",
      "Develop future leaders through mentoring.",
      "Understand biblical church administration and governance.",
      "Lead with accountability, wisdom, and professionalism."
    ],
    curriculum: [
      {
        week: 1,
        title: "Foundations of Secondary Leadership",
        subtitle: "Understanding the Call to Serve",
        topics: [
          "Biblical principles of secondary leadership",
          "The purpose of supporting leadership",
          "Servant leadership",
          "Leadership identity",
          "Biblical models of secondary leaders"
        ]
      },
      {
        week: 2,
        title: "The Weight of Leadership",
        subtitle: "Carrying Responsibility with Excellence",
        topics: [
          "Leadership responsibility",
          "Personal accountability",
          "Emotional maturity",
          "Leadership under pressure",
          "Building trust"
        ]
      },
      {
        week: 3,
        title: "The Heart of a Servant Leader",
        subtitle: "Character Before Position",
        topics: [
          "Biblical servanthood",
          "Humility",
          "Integrity",
          "Faithfulness",
          "Spiritual maturity"
        ]
      },
      {
        week: 4,
        title: "Honor, Loyalty & Leadership",
        subtitle: "Serving Authority with Integrity",
        topics: [
          "Biblical honor",
          "Healthy loyalty",
          "Protecting unity",
          "Following leadership",
          "Biblical submission"
        ]
      },
      {
        week: 5,
        title: "Vision Stewardship",
        subtitle: "Protecting and Advancing the Vision",
        topics: [
          "Vision alignment",
          "Organizational unity",
          "Vision communication",
          "Stewardship of assignments",
          "Vision execution"
        ]
      },
      {
        week: 6,
        title: "Biblical Administration & Delegation",
        subtitle: "Building Systems That Sustain the Vision",
        topics: [
          "Delegation",
          "Organizational systems",
          "Ministry administration",
          "Executive organization",
          "Leadership structure"
        ]
      },
      {
        week: 7,
        title: "Executive Stewardship",
        subtitle: "Managing What Belongs to Another",
        topics: [
          "Stewardship principles",
          "Executive responsibility",
          "Accountability",
          "Confidentiality",
          "Organizational trust"
        ]
      },
      {
        week: 8,
        title: "Executive Priorities & Ministry Productivity",
        subtitle: "Managing Time, Pressure & Purpose",
        topics: [
          "Time management",
          "Executive productivity",
          "Strategic planning",
          "Ministry priorities",
          "Healthy leadership habits"
        ]
      },
      {
        week: 9,
        title: "Building & Developing Leadership Teams",
        subtitle: "Multiplying Leaders",
        topics: [
          "Mentorship",
          "Leadership pipeline",
          "Succession preparation",
          "Team building",
          "Leadership development"
        ]
      },
      {
        week: 10,
        title: "Conference & Event Leadership",
        subtitle: "Planning Ministry with Excellence",
        topics: [
          "Conference planning",
          "Event management",
          "Volunteer coordination",
          "Budgeting",
          "Ministry logistics",
          "Executive event leadership"
        ]
      },
      {
        week: 11,
        title: "Church Administration, Governance & Executive Leadership",
        subtitle: "Establishing Order That Protects the Vision",
        topics: [
          "Church administration",
          "Biblical governance",
          "Organizational structure",
          "Leadership policies",
          "Executive leadership",
          "Ministry operations"
        ]
      },
      {
        week: 12,
        title: "The Trusted Secondary Leader",
        subtitle: "Finishing Well, Leaving a Legacy & Preparing the Next Generation",
        topics: [
          "Leadership legacy",
          "Finishing well",
          "Leadership philosophy",
          "Personal leadership covenant",
          "Graduation and commissioning"
        ]
      }
    ],
    included: [
      "Student Textbook",
      "Instructor-Led Weekly Classes",
      "Weekly Leadership Assignments",
      "Leadership Development Tools",
      "Executive Resource Manual",
      "Church Administration Templates",
      "Simple Church Bylaws",
      "Simple Succession Plan",
      "Organizational Charts",
      "Leadership Meeting Templates",
      "Conference Planning Templates",
      "Executive Planning Forms",
      "Ministry Administration Documents",
      "Certificate of Completion"
    ],
    audience: [
      "Executive Pastors",
      "Assistant Pastors",
      "Associate Pastors",
      "Elders",
      "Ministers",
      "Deacons",
      "Church Administrators",
      "Ministry Leaders",
      "Department Directors",
      "Executive Assistants",
      "Church Secretaries",
      "Nonprofit Leaders",
      "Emerging Leaders",
      "Anyone called to support and strengthen leadership"
    ],
    differentiators: [
      "Biblical Leadership Principles",
      "Executive Leadership Training",
      "Church Administration",
      "Practical Ministry Operations",
      "Conference & Event Management",
      "Leadership Development",
      "Executive Resource Documents",
      "Real-World Administrative Tools"
    ]
  },

  clothier: {
    title: "Clothier",
    subtitle: "Gifted to Create • Driven to Build",
    description: "Master craftsmanship meets elegant design in custom suits and dresses that celebrate your unique style and confidence.",
    services: [
      {
        id: 1,
        name: "Online Self Service",
        description: "Design your custom suit online with our intuitive self-service platform. Choose fabrics, styles, and measurements from the comfort of your home.",
        features: ["Online design tool", "Wide fabric selection", "Self-measurement guide", "Direct shipping"],
        startingPrice: "$249.00",
        link: "https://quinel.mastertailorstudio.com/products/",
        external: true
      },
      {
        id: 3,
        name: "Design, Style and Fit with Clothier Consultation",
        description: "Complete personalized service with direct clothier consultation for the ultimate custom experience.",
        features: ["One-on-one consultation", "Personal style analysis", "Premium fabric selection", "Multiple fittings", "Lifetime alterations"],
        startingPrice: "$1,200"
      },
      {
        id: 4,
        name: "Custom Women's Dresses and Suits",
        description: "Elegant custom dresses and suits designed specifically for women, combining style and sophistication.",
        features: ["Women's style expertise", "Custom fit", "Designer fabrics", "Professional consultation"],
        startingPrice: "Coming Soon",
        status: "coming-soon"
      }
    ],
    gallery: [
      {
        id: 1,
        title: "Classic Business Suit",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=800&fit=crop",
        category: "men"
      },
      {
        id: 2,
        title: "Evening Gown",
        image: "https://images.unsplash.com/photo-1566479179817-30b7bbfb9cb8?w=600&h=800&fit=crop",
        category: "women"
      },
      {
        id: 3,
        title: "Wedding Tuxedo",
        image: "https://images.unsplash.com/photo-1521341957697-b93449760f30?w=600&h=800&fit=crop",
        category: "wedding"
      },
      {
        id: 4,
        title: "Formal Dress",
        image: "https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=600&h=800&fit=crop",
        category: "women"
      },
      {
        id: 5,
        title: "Three-Piece Suit",
        image: "https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=600&h=800&fit=crop",
        category: "men"
      },
      {
        id: 6,
        title: "Bridal Gown",
        image: "https://images.unsplash.com/photo-1465495976277-4387d4b0e4a6?w=600&h=800&fit=crop",
        category: "wedding"
      }
    ],
    process: [
      {
        step: 1,
        title: "Consultation",
        description: "We discuss your vision, style preferences, and occasion requirements."
      },
      {
        step: 2,
        title: "Design & Fabric Selection",
        description: "Choose from our premium fabric collection and finalize the design details."
      },
      {
        step: 3,
        title: "Measurements & Fitting",
        description: "Precise measurements and multiple fittings ensure a perfect fit."
      },
      {
        step: 4,
        title: "Creation & Delivery",
        description: "Master craftsmen create your garment with attention to every detail."
      }
    ]
  },

  testimonials: [
    {
      id: 1,
      name: "James Williams",
      role: "Business Executive",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
      quote: "Romero created the perfect suit for my wedding. The attention to detail and craftsmanship is unmatched. I've never felt more confident!",
      service: "clothier"
    },
    {
      id: 2,
      name: "Lisa Thompson",
      role: "Church Member",
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b8aa?w=150&h=150&fit=crop&crop=face",
      quote: "Pastor Sumpter's messages have transformed my life. His book 'Love Through It All' helped me through my darkest times.",
      service: "ministry"
    },
    {
      id: 3,
      name: "Maria Rodriguez",
      role: "Bride",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      quote: "My custom wedding dress was absolutely perfect. Romero understood my vision and created something beyond my dreams.",
      service: "clothier"
    }
  ],

  contact: {
    email: "romero.sumpter@gmail.com",
    businessHours: {
      general: "All services available by appointment only via email"
    },
    social: {
      facebook: "#",
      instagram: "#",
      youtube: "#",
      twitter: "#"
    }
  }
};